import styled from 'styled-components';

const SearchCustomerWithInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;

export default SearchCustomerWithInputWrapper;
